import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import actions from './actions';
import AppActions from '../App/actions';
import {get} from 'bukku/shared/ApiService';

export function* readPublicCountriesRequest() {
    yield takeEvery(actions.PUBLIC_LIST_READ_COUNTRIES_REQUEST, function* (action, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/public/countries', null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.PUBLIC_LIST_READ_COUNTRIES_SUCCESS,
                countries: data.countries,
            });
        }
        catch (error) {
            yield put({
                type: actions.PUBLIC_LIST_READ_COUNTRIES_FAILURE,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}

export function* readPublicStatesRequest() {
    yield takeEvery(actions.PUBLIC_LIST_READ_STATES_REQUEST, function* ({countryCode}, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, `/public/states`, {countryCode}, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.PUBLIC_LIST_READ_STATES_SUCCESS,
                states: data.states,
            });
        }
        catch (error) {
            yield put({
                type: actions.PUBLIC_LIST_READ_STATES_FAILURE,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}

export function* readPublicCurrenciesRequest() {
    yield takeEvery(actions.PUBLIC_LIST_READ_CURRENCIES_REQUEST, function* (action, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/public/currencies', null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.PUBLIC_LIST_READ_CURRENCIES_SUCCESS,
                currencies: data.currencies,
            });
        }
        catch (error) {
            yield put({
                type: actions.PUBLIC_LIST_READ_CURRENCIES_FAILURE,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}

export function* readPublicMsicCodeRequest() {
    yield takeEvery(actions.PUBLIC_LIST_READ_MSIC_CODE_REQUEST, function* (action, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/public/msic_codes', null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.PUBLIC_LIST_READ_MSIC_CODE_SUCCESS,
                msicCodes: data.msic_codes,
            });
        }
        catch (error) {
            yield put({
                type: actions.PUBLIC_LIST_READ_MSIC_CODE_FAILURE,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}

export default function* rootSaga() {
    yield all([
        fork(readPublicCountriesRequest),
        fork(readPublicStatesRequest),
        fork(readPublicCurrenciesRequest),
        fork(readPublicMsicCodeRequest),
    ]);
}
